import { Controller } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import {
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	FormWrapperLabel,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { useEffect, useRef } from 'react';
import { UnreadType } from '../../../Types/MailFilterDataTypes';
import { SearchTypesType } from '../SearchControlTypes';

function SearchMailStatus(props: SearchTypesType) {
	const { t } = useTranslation();

	const inputRef = useRef<HTMLInputElement | null>(null);

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.value = props.searchParams?.get('unreadStatus')
				? (props.searchParams.get('unreadStatus') as string)
				: '';
		}
	}, [props.searchParams]);

	return (
		<Controller
			name='unreadStatus'
			control={props.formMethods.control}
			render={({ field, fieldState }) => (
				<FormWrapperLabel
					label={t('mailboxes.filter.labels.unreadStatus')}
					invalid={fieldState.invalid}
					validationMessage={fieldState.error?.message}
				>
					<ComboBoxControl
						name='unreadStatus'
						placeholder={t('mailboxes.filter.controls.unreadStatusPlaceholder')}
						data={UnreadType}
						valueType='number'
						displayType={ComboBoxTypeEnum.Single}
						displayItemLabelType={ComboBoxItemDisplayEnum.Label}
						defaultValue={
							props.searchParams?.get('unreadStatus')
								? [props.searchParams?.get('unreadStatus') as string]
								: undefined
						}
						forwardValueCallback={(e) => {
							field.onChange(e);
						}}
					/>
				</FormWrapperLabel>
			)}
		/>
	);
}

export { SearchMailStatus };
